
export const NOTIFICACION_ESTADO = {

    LEIDO: 1,
    NO_LEIDO: 2

}